import { Link } from "react-router-dom";
import { Checkbox } from "@/components/ui/checkbox";
import { useTranslation } from "@/contexts/LanguageContext";

export default function ProjectChecklist({ projectId, items, checked, onToggle, signedIn }) {
  const { lang } = useTranslation();
  const es = lang === "es";
  const done = checked.length;
  return (
    <div className="bg-[#0A0A0A] border border-white/10 rounded-lg p-3" data-testid={`checklist-${projectId}`}>
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-[#F5A524] text-xs font-semibold uppercase tracking-widest">
          {es ? "Lista de Entregables" : "Deliverables Checklist"}
        </h4>
        <span className="font-['JetBrains_Mono'] text-xs text-[#A1A1AA]" data-testid={`checklist-count-${projectId}`}>
          {done}/{items.length}
        </span>
      </div>
      <div className="space-y-2">
        {items.map((label, i) => {
          const id = `chk-${projectId}-${i}`;
          return (
            <label key={id} htmlFor={id} className="flex items-start gap-2.5 cursor-pointer group">
              <Checkbox
                id={id}
                checked={checked.includes(i)}
                disabled={!signedIn}
                onCheckedChange={() => onToggle(i)}
                className="mt-0.5 border-white/30 data-[state=checked]:bg-[#F5A524] data-[state=checked]:border-[#F5A524] data-[state=checked]:text-[#0A0A0A]"
                data-testid={`checklist-item-${projectId}-${i}`}
              />
              <span className={`text-sm transition-colors ${checked.includes(i) ? "text-[#71717A] line-through" : "text-white group-hover:text-[#F5A524]"}`}>
                {label}
              </span>
            </label>
          );
        })}
      </div>
      {!signedIn && (
        <p className="text-[#71717A] text-xs mt-3" data-testid={`checklist-signin-${projectId}`}>
          <Link to="/login" className="text-[#F5A524] hover:underline">{es ? "Inicia sesión" : "Sign in"}</Link>
          {es ? " para guardar tu progreso." : " to save your progress."}
        </p>
      )}
    </div>
  );
}
